import { IRouterUtilConfiguration } from '../router-util.interface';

export const configuration: Partial<IRouterUtilConfiguration> = {
  GameHistory: 'tournaments/gamehistory/view',
  Profile: '',
};
